/**
 * App-wide ApexCharts defaults (window.Apex is merged into every chart's
 * options before its own, so a chart can still override).
 *
 * Wheel zoom off: scrolling down a page or modal over a chart zoomed the chart
 * under the cursor and silently changed its date range. Zoom stays available
 * from the toolbar buttons and by dragging a selection.
 */
const current = (typeof window !== "undefined" && window.Apex) || {};

if (typeof window !== "undefined") {
  window.Apex = {
    ...current,
    chart: {
      ...(current.chart || {}),
      zoom: {
        ...((current.chart || {}).zoom || {}),
        allowMouseWheelZoom: false,
      },
    },
  };
}
